import { PaymentMethod } from "@omni/types/components/payment/paymentMethod.model";

export const $PaymentMethodsModuleName = "paymentMethods";

export type TPaymentMethodsState = Array<PaymentMethod>;
